webpackJsonp([164462042901195],{

/***/ 1314:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":{"edges":[{"node":{"title":"The Beginning of Code Fellows","metaDescription":"Looking for resources as you learn to code? The Code Fellows blog features helpful tutorials, alumni stories, student projects, school news, and more!","slug":"blog/the-beginning-of-code-fellows","createdAt":"2013-11-08T03:57:27.615Z","blogAuthor":{"fields":{"name":"Andy Sack","slug":"blog/author/andy-sack"}},"imageHeader":null}}]},"authorJson":{"name":"Andy Sack","slug":"blog/author/andy-sack","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/andy-sack"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-andy-sack-4be1b792c10d592a4814.js